import { get, call } from 'vuex-pathify'
export default {
  computed: {
    ...get({
      sortedCategories: 'kintell/sortedCategories',
      isCategoriesLoading: 'kintell/categoriesLoading'
    }),
  },
  methods: {
    ...call({
      loadCategories: 'kintell/loadCategories'
    })
  },
  mounted () {
    this.loadCategories()
  }
}
